export const i18KeyMaker = (
  commonRoot: string,
  isOnline: boolean,
  offlineSuffix: string,
  onlineSuffix: string
) => commonRoot + (isOnline ? onlineSuffix : offlineSuffix);
